import React, { FunctionComponent } from 'react';

import { InsuredItem, SingleFieldStepProps } from 'scenes/common/types';
import SingleYesNoStep from 'scenes/common/components/Steps/SingleYesNoStep';

const HERITAGE_LISTED = 'heritageListed';

const HeritageListedStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'onNext' | 'defaultStateValue'> & {
    insuredItem: InsuredItem;
  }
> = ({ onNext, defaultStateValue, insuredItem }) => {
  const question = `Is the ${insuredItem} Heritage listed?`;

  return (
    <SingleYesNoStep
      question={question}
      stateKey={HERITAGE_LISTED}
      defaultStateValue={defaultStateValue}
      onNext={onNext}
    />
  );
};

export default HeritageListedStep;
